<!--
 * @Author: zl
 * @Date: 2022-09-15 15:16:19
 * @LastEditTime: 2022-09-16 17:27:31
 * @LastEditors: zl
 * @Description: 周报月报
-->
<template>
	<div class='WeeklyOrMonthly-layout'>
		<el-row>
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">报 告</h2>
				<el-descriptions :column="2"
								 size="small"
								 border
								 class="custom-descriptions">
					<el-descriptions-item label="工程项目名称"
										  :span="2">{{ currentObj.proName }}</el-descriptions-item>
					<el-descriptions-item label="关联审计任务"
										  :span="2">{{ form.taskName }}</el-descriptions-item>
					<el-descriptions-item label="报告标题"
										  :span="2">{{ form.title }}</el-descriptions-item>
					<el-descriptions-item label="报告日期"
										  :span="2">
						{{ form.reportTime ? form.reportTime.substr(0, 10) : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="报告类型">{{ form.typeName }}</el-descriptions-item>
					<el-descriptions-item label="模板">{{ form.templateName }}</el-descriptions-item>
					<template v-if="form.type && form.type.includes('1019002002')">
						<el-descriptions-item label="审核产值 (元)">{{ form.auditOutput }}</el-descriptions-item>
						<el-descriptions-item label="审核进度款 (元)">{{ form.auditProValue }}</el-descriptions-item>
						<el-descriptions-item label="申报产值 (元)">{{ form.decOutput }}</el-descriptions-item>
						<el-descriptions-item label="申报进度款 (元)">{{ form.decProValue }}</el-descriptions-item>
					</template>
					<el-descriptions-item label="报告内容"
										  :span="2"
										  contentClassName="h200">
						<div class="quill-editor editor w100">
							<div class="ql-container">
								<div class="ql-editor">
									<div class="content"
										 v-html="form.content"></div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="上传附件"
										  :span="2">
						<myUpload listType="list"
								  ref="meetingUpload"
								  tableName="audit_wm_report"
								  assortment="test2"
								  uploadType="2"
								  width="auto"
								  height="auto"
								  :aid="form.id"
								  mode="view"
								  class="h100 w100"></myUpload>
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.selectWmReportDetail({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
</style>